import React from 'react';
import { TopicConfigType } from 'src/pages/Backstage/subPages/DataSource/TopicConfig/types';
import { getIconContent } from 'src/pages/Backstage/subPages/DataSource/TopicConfig/utils';
import { parseFileUrl } from 'src/utils/urlUtils';

const TopicIcon: React.FC<{
  topicInfo?: TopicConfigType.DataItem | null;
  size: number;
  className?: string;
  contentLength?: number;
}> = ({ topicInfo, className, contentLength = 4, size }) => {
  return (
    <div
      className={`rounded-[10px] overflow-hidden !text-[0.7em] ${className}`}
      css={{ width: size + 'px', height: size + 'px' }}
    >
      {topicInfo?.icon ? (
        <img src={parseFileUrl(topicInfo.icon)} className="w-full h-full" />
      ) : (
        <div
          className="w-full h-full leading-[1.2] overflow-hidden whitespace-pre-wrap flex items-center justify-center bg-[#5687FF] text-white text-center p-[4px]"
          style={{ fontSize: 'inherit !important', lineHeight: 'inherit' }}
        >
          {getIconContent(topicInfo?.name, contentLength)}
        </div>
      )}
    </div>
  );
};
export default TopicIcon;
